import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'EcommOptionsList',
})(({ spacing, type }) => ({
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,

    '& > li': { padding: `calc(${spacing(1)} / 2) 0` },
    '& > :first-child': { paddingTop: `0` },
    '& > :last-child': { paddingBottom: `0` },
  },
  notAvailable: {
    paddingLeft: spacing(1),
    ...type['12_regular'],
  },
}));

export default useStyles;
